export const onInitialClientRender = () => {
  window.scrollTo(0, 0); // Force le scroll en haut lors du premier rendu
};
